import { notifications } from '@mantine/notifications';
import { IconCheck } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';
import { INSTANCE_LIST_QUERY_KEY } from './useInstanceListQuery';

export function useDestroyInstanceMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: any) => Endpoints.v1.Instances.deleteInstance(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: INSTANCE_LIST_QUERY_KEY });
            notifications.show({
                title: t('instance.destroyRequestTitle'),
                message: t('instance.destroyRequestMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('instance.destroyRequestFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconCheck size={32} color={'#eb5757'} />,
            });
        },
    });
}
